'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoArrowUpC = function IoArrowUpC(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10.2 14.8l8.2-7.8c0.5-0.5 1.1-0.7 1.8-0.7s1.3 0.2 1.7 0.7l8.3 7.8c0.9 0.9 0.9 2.4 0 3.3s-2.7 1-3.6 0l-3.9-3.7v16.9c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-16.9l-3.9 3.8c-0.9 0.9-2.7 0.9-3.6 0s-0.9-2.5 0-3.4z' })
        )
    );
};

exports.default = IoArrowUpC;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/arrow-up-c.js
// module id = 1982
// module chunks = 0